<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card :loading="loading">
          <v-card-title>Heartbeats for {{ pmsConnDetails.usr }}</v-card-title>
          <v-card-subtitle>{{ pmsConnDetails.pmsType }}</v-card-subtitle>

<v-container>
  <v-row>
    <v-col>
<v-datetime-picker
              label="From"
              v-model="start"
              dateFormat="dd/MM/yyyy"
              timeFormat="hh:mm aa"
              :text-field-props="textFieldProps"
              class="pa-10"
            >
              <template v-slot:dateIcon>
                Date
              </template>
              <template v-slot:timeIcon>
                Time
              </template>
            </v-datetime-picker>
    </v-col>

    <v-col>
<v-datetime-picker
            class="pa-10"
              label="To"
              v-model="end"
              dateFormat="dd/MM/yyyy"
              timeFormat="hh:mm aa"
              
              :text-field-props="textFieldProps"
            >
              <template v-slot:dateIcon>
                Date
              </template>
              <template v-slot:timeIcon>
                Time
              </template>
            </v-datetime-picker>
    </v-col>

    <v-col >
      
            <v-btn color="primary" :loading="loading" @click="getHeartbeats(sub)" right>
              Search Dates
            </v-btn>
    </v-col>

  </v-row>
  <v-row>
    <v-col cols="8">

            <v-text-field
              v-model="search"
              :disabled="!heartbeats.length"
              append-icon="mdi-magnify"
              label="Filter Results"
              single-line
              hide-details
              dense
            ></v-text-field>
    </v-col>

    <v-col cols="4">

            <template>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                                  <v-btn
                                  :disabled="!nextToken"
              v-if="nextToken"
              :loading="loading"
              color="success"
              small
              @click="getHeartbeats(sub, nextToken)"
            >
              Get More Results for Dates
            </v-btn>
                    </span>
                  </template>
                  <span>Your date range query matched more than {{maxItems}} results. Get the next batch of results in your date range by clicking here.</span>
                </v-tooltip>
            </template>
    </v-col>    
  </v-row>

</v-container>

          <v-data-table
            :headers="headers"
            :items="heartbeats"
            :loading="loading"
            :fixed-header="true"
            :search="search"
            item-key="ctdTs"
            :dense="true"
          >
            <template v-slot:item.ctdTs="{ item }">
              <template v-if="!item.ctdTs">n/a</template>
              <template v-else-if="showTimeAgo(item.ctdTs)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <timeago
                        :datetime="item.ctdTs"
                        :auto-update="60"
                        :converterOptions="{ includeSeconds: true }"
                      ></timeago>
                    </span>
                  </template>
                  <span>{{
                    new Date(item.ctdTs).toLocaleString("en-AU")
                  }}</span>
                </v-tooltip>
              </template>
              <template v-else>
                {{ new Date(item.ctdTs).toLocaleString("en-AU") }}
              </template>
            </template>
            <template v-slot:item.lastReadFromPms="{ item }">
              {{ new Date(item.lastReadFromPms).toLocaleString("en-AU") }}
            </template>

            <template v-slot:item.pmsStatus="{ item }">
              {{ item.pmsStatus | pmsStatus }}
            </template>

            <template v-slot:item.pmsVersion="{ item }">
              {{ item.pmsVersion | versionFilter }}
            </template>

            <template v-slot:item.processUptime="{ item }">
              <template v-if="!item.processUptime">n/a</template>
              <template v-else>{{
                formatSeconds(item.processUptime)
              }}</template>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";

export default {
  props: {
    pmsConnDetails: Object,
  },
  data: function () {
    return {
      heartbeats: [],
      loading: false,
      search: "",
      sub: "",
      start: new Date(),
      end: new Date(),
      nextToken: "",
      maxItems: 100,
      textFieldProps: {
        appendIcon: 'mdi-calendar',
        dense: true,
        class: ''
      },
      headers: [
        {
          text: "Received",
          align: "left",
          sortable: true,
          value: "ctdTs",
        },
        { text: "App Version", value: "appVersion", sortable: true },
        { text: "PMS Status", value: "pmsStatus", sortable: true },
        { text: "PMS Version", value: "pmsVersion", sortable: true },
        { text: "Last PMS Read", value: "lastReadFromPms", sortable: true },
        { text: "Source IP", value: "sip" },
        { text: "Host System Name", value: "systemName" },
        { text: "Host Local IP", value: "systemIp" },
        { text: "Host OS", value: "systemOs" },
        { text: "Host .NET FW", value: "dotNet" },
        { text: "Process ID", value: "processId" },
        { text: "Process Uptime", value: "processUptime" },
        { text: "Host Install Path", value: "exePath" },
        { text: "App Name", value: "exeName" },
      ],
    };
  },
  created: async function () {
    this.sub = this.$route.params.sub;
    const start = new Date();
    start.setHours(0, 0, 0);
    start.setDate(start.getDate()-3); // 3 days ago by default
    this.start = start;

    const end = new Date();
    end.setHours(23, 59, 59, 999);
    this.end = end;

    await this.getHeartbeats(this.sub);
  },
  filters: {
    versionFilter: function (value) {
      try {
        const json = JSON.parse(decodeURIComponent(value));

        if (!json || typeof json !== "object") {
          return value;
        }
        const out = [];
        for (var key in json) {
          out.push(`${key}: ${json[key]}`);
        }
        return out.join(", ");
      } catch (err) {
        return value;
      }
    },
    pmsStatus: function (value) {
      switch (value) {
        case "OK":
          return "Connected";
          break;
        case "NotImplemented":
          return "n/a";
          break;
        default:
          return value;
      }
    },
  },
  methods: {
    async getHeartbeats(sub, nextToken) {
      try {
        this.loading = true;

        const hbs = await API.graphql(
          graphqlOperation(queries.listHeartbeats, {
            filter: {
              sub,
              ctdTs: { between: [this.start.getTime(), this.end.getTime()] },
            },
            nextToken,
            limit: this.maxItems
          })
        );

        console.info("listHearbeats response", hbs);

        if ((hbs.data?.listHeartbeats?.items?.length ?? 0) <= 0) {
          this.heartbeats = this.nextToken ? this.heartbeats : [];
          return;
        }

        this.heartbeats = nextToken
          ? this.heartbeats.concat(hbs.data.listHeartbeats?.items ?? [])
          : hbs.data.listHeartbeats?.items ?? [];
        this.nextToken = hbs.data.listHeartbeats?.nextToken ?? "";
      } finally {
        this.loading = false;
      }
    },
    formatSeconds(secs) {
      //return secs;
      const date = new Date(null);
      date.setSeconds(secs); // specify value for SECONDS here
      return date.toISOString().substr(11, 8);
    },
    showTimeAgo(ts) {
      const hour = 120 * 60 * 1000;
      return ts > Date.now() - hour ? true : false;
    },
    getDateTs(someDate) {},
  },
};
</script>